import { render, staticRenderFns } from "./overview-saved-assessments.vue?vue&type=template&id=dd39c18c&scoped=true&"
import script from "./overview-saved-assessments.vue?vue&type=script&lang=js&"
export * from "./overview-saved-assessments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd39c18c",
  null
  
)

export default component.exports